export default __webpack_public_path__ + "static/media/logo.a98a9f0c.svg";